// extracted by mini-css-extract-plugin
export var chronoDate = "ResultsPage-module--chronoDate--o4-55";
export var resultsChrono = "ResultsPage-module--resultsChrono--2sIge";
export var resultsTimeOnly = "ResultsPage-module--resultsTimeOnly--3zHrb";